import script from "./approvalInventory.vue?vue&type=script&setup=true&lang=js"
export * from "./approvalInventory.vue?vue&type=script&setup=true&lang=js"

import "./approvalInventory.vue?vue&type=style&index=0&id=7a4d7df9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a4d7df9"]])

export default __exports__